import { ChangeEvent } from 'react'
import { TbCheck } from 'react-icons/tb'
import { Text } from 'ui-kit/typography'
import { filtersData } from './filtersData'
import classes from './IntegrationsFilters.module.scss'

export const IntegrationsFilters = ({ value: filtersValue, onChange }) => {
  function handleFilterSelect(e: ChangeEvent<HTMLInputElement>) {
    const checkedFilter = e.target.value
    const isChecked = e.target.checked

    if (isChecked) {
      onChange([...filtersValue, checkedFilter])
    } else {
      onChange(filtersValue.filter((i: string) => i !== checkedFilter))
    }
  }

  return (
    <div className={classes.wrapper}>
      <form className={classes.form}>
        <Text lh={'tight'} className={classes.caption}>
          Filters:
        </Text>
        {filtersData.map(({ name, value, title }) => (
          <Text as={'label'} lh={'tight'} className={classes.label} key={value}>
            <input
              type='checkbox'
              name={name}
              value={value}
              checked={filtersValue?.includes(value)}
              onChange={handleFilterSelect}
              className={classes.checkbox}
            />
            {title}
            <CustomCheckbox />
          </Text>
        ))}
      </form>
    </div>
  )
}

export const CustomCheckbox = () => {
  return (
    <div className={classes.customCheckbox}>
      <TbCheck className={classes.icon} />
    </div>
  )
}
